import type { ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { tokens } from '../../theme/tokens';
import { AppText } from './AppText';

type AppBadgeTone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';

type AppBadgeProps = {
  label: string;
  tone?: AppBadgeTone;
  leftSlot?: ReactNode;
  style?: StyleProp<ViewStyle>;
};

export function AppBadge({ label, tone = 'neutral', leftSlot, style }: AppBadgeProps) {
  return (
    <View style={[styles.badge, styles[tone], style]}>
      {leftSlot}
      <AppText variant="caption" weight="semibold" tone={tone === 'neutral' ? 'muted' : tone === 'brand' ? 'primary' : tone}>
        {label}
      </AppText>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    minHeight: tokens.component.badge.height,
    borderRadius: tokens.component.badge.radius,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: tokens.spacing.xs,
    paddingHorizontal: tokens.component.badge.paddingHorizontal,
  },
  brand: {
    backgroundColor: tokens.colors.dangerSoft,
  },
  success: {
    backgroundColor: tokens.colors.successSoft,
  },
  warning: {
    backgroundColor: tokens.colors.warningSoft,
  },
  danger: {
    backgroundColor: tokens.colors.dangerSoft,
  },
  neutral: {
    backgroundColor: tokens.colors.surfaceMuted,
  },
});
